import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';

import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShower, faCartShopping, faGlassMartini, faFistRaised, faRedo, faComment, faEdit, faPlusSquare, faBookAtlas, faSchoolCircleCheck, faQrcode, faList, faListUl } from '@fortawesome/free-solid-svg-icons';
import './BeSure.css';

const BeSureUploadData = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  // Handle file selection
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  // Validate and parse CSV file
  const handleFileUpload = async () => {
    if (!file) {
      setError('Please select a file first.');
      return;
    }
    if (file.type !== 'text/csv') {
      setError('Please upload a CSV file.');
      return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const text = e.target.result;
      const rows = text.split('\n').slice(1); // Skip the header row

      const validData = rows
        .map((row) => {
          const [productCode, productName, productBrand, batchNumber, mfgDate, expDate, productBrief] = row.split(',');

          // Basic validation
          if (productCode && productCode.startsWith('BS') && productCode.length === 16) {
            return {
              productCode,
              productName,
              productBrand,
              batchNumber,
              mfgDate: new Date(mfgDate),
              expDate: new Date(expDate),
              productBrief,
            };
          }
          return null;
        })
        .filter((item) => item !== null);

      if (validData.length === 0) {
        setError('No valid data found in the CSV file.');
        return;
      }

      try {
        const config = { 
          url: `/besurebank/import`, 
          method: 'post',
          headers: { Authorization: authState.token }, 
          data: validData,
        };
        const response = await fetchData(config);

        if (!response.status) {
          setError(response.message || 'Error importing data.');
        } else {
          setMessage('Data imported successfully!');
          setError('');
        }
      } catch (err) {
        setError('Error importing data.');
        console.error(err);
      }
    };

    reader.onerror = () => {
      setError('Error reading the file.');
    };

    reader.readAsText(file);
  };

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mx-2 border-b border-b-gray-300 text-white'>BeSure - Check Product</h2>
      </div>
      <div className="m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full">
      {/* <div className='flex flex-col items-center p-6 bg-gray-800 rounded-lg shadow-md'> */}
        <h1 className='text-3xl font-bold text-white mb-4'>Upload Product Data</h1>
        <div className='w-full max-w-md'>
          <input
            type='file'
            accept='.csv'
            onChange={handleFileChange}
            className='mb-4 p-2 border border-gray-600 rounded-md'
          />
          <button
            onClick={handleFileUpload}
            className='w-full py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700'
          >
            Upload CSV
          </button>
          {message && <p className='mt-4 text-green-500'>{message}</p>}
          {error && <p className='mt-4 text-red-500'>{error}</p>}
        </div>
      </div>
    </MainLayout>
  );
};

export default BeSureUploadData;
